import { jsx } from "react/jsx-runtime";
import { StyledImage } from "@zillow/constellation";
import styled from "styled-components";
import { BLOCK_MAPPING } from "../../constants/blocks.esm.js";
import BlocksContext from "./BlockContext.esm.js";
import BlockErrorBoundary from "./BlockErrorBoundary.esm.js";
const BlockListWrapper = /* @__PURE__ */ styled.div.withConfig({
  displayName: "BlockList__BlockListWrapper",
  componentId: "sc-rwneio-0"
})(["", "{max-width:100%;height:auto;}"], StyledImage);
const BlockList = ({
  blocks
}) => {
  return /* @__PURE__ */ jsx(BlocksContext.Provider, { value: {
    rootBlocks: blocks
  }, children: /* @__PURE__ */ jsx(BlockListWrapper, { children: blocks.map((block, index) => {
    if (BLOCK_MAPPING[block.blockName]) {
      const Block = BLOCK_MAPPING[block.blockName];
      const Component = (Block == null ? void 0 : Block.Component) ? Block.Component : Block;
      return /* @__PURE__ */ jsx(BlockErrorBoundary, { blockName: block.blockName, children: /* @__PURE__ */ jsx(Component, { ...block }) }, String(index));
    }
    return null;
  }) }) });
};
const generateBlockList = ({
  blocks = []
}) => {
  return blocks.map((block, index) => {
    if (BLOCK_MAPPING[block.blockName]) {
      const Block = BLOCK_MAPPING[block.blockName];
      const Component = (Block == null ? void 0 : Block.Component) ? Block.Component : Block;
      return /* @__PURE__ */ jsx(BlockErrorBoundary, { blockName: block.blockName, children: /* @__PURE__ */ jsx(Component, { ...block }) }, String(index));
    }
    return null;
  });
};
export {
  BlockList as default,
  generateBlockList
};
